import { NetworkQuestionsEnablementMode } from '@ms/yammer-graphql';

import { Experiment, YammerState } from '../../state/types';
import { getExperimentTreatment } from '../experiments/selectors';
import { getFeatureAccessSettings, getNetworkQuestionsEnablementMode } from '../featureAccessSettings/selectors';
import { isCurrentNetworkOfficeTopicsEnabled } from '../networkTopicSettings/selectors';

enum NetworkQuestionsAccess {
  Disabled = 'Disabled',
  EnabledButNotLicensed = 'EnabledButNotLicensed',
  EnabledAndLicensed = 'EnabledAndLicensed',
}

type GetNetworkQuestionsAccess = (state: YammerState) => NetworkQuestionsAccess;
const getNetworkQuestionsAccess: GetNetworkQuestionsAccess = (state) => {
  const isNetworkQuestionsEnabled =
    getNetworkQuestionsEnablementMode(state) !== NetworkQuestionsEnablementMode.DISABLED;
  const viewerCanAccessNetworkQuestions = !!getFeatureAccessSettings(state)?.viewerCanAccessNetworkQuestions;
  const isOfficeTopicsEnabledForNetwork = isCurrentNetworkOfficeTopicsEnabled(state);
  const isOfficeTopicsFlighted = getExperimentTreatment(state, Experiment.OfficeTopics) === true;
  const isAnswersInVivaGAFlighted = getExperimentTreatment(state, Experiment.AnswersInVivaGA) === true;

  if (
    !isAnswersInVivaGAFlighted ||
    !isOfficeTopicsFlighted ||
    !isNetworkQuestionsEnabled ||
    !isOfficeTopicsEnabledForNetwork
  ) {
    return NetworkQuestionsAccess.Disabled;
  }

  if (!viewerCanAccessNetworkQuestions) {
    return NetworkQuestionsAccess.EnabledButNotLicensed;
  }

  return NetworkQuestionsAccess.EnabledAndLicensed;
};

type IsNetworkQuestionsDisabled = (state: YammerState) => boolean;
export const isNetworkQuestionsDisabled: IsNetworkQuestionsDisabled = (state) =>
  getNetworkQuestionsAccess(state) === NetworkQuestionsAccess.Disabled;

type IsNetworkQuestionsEnabledButNotLicensed = (state: YammerState) => boolean;
export const isNetworkQuestionsEnabledButNotLicensed: IsNetworkQuestionsEnabledButNotLicensed = (state) =>
  getNetworkQuestionsAccess(state) === NetworkQuestionsAccess.EnabledButNotLicensed;

type IsNetworkQuestionsEnabledAndLicensed = (state: YammerState) => boolean;
export const isNetworkQuestionsEnabledAndLicensed: IsNetworkQuestionsEnabledAndLicensed = (state) =>
  getNetworkQuestionsAccess(state) === NetworkQuestionsAccess.EnabledAndLicensed;
